import { useEffect } from 'react';
import { useSettings } from '../contexts/SettingsContext';

/**
 * Custom hook to dynamically set the page title
 * @param title - The title to set for the page
 * @param customBaseTitle - Optional custom base title to override the site name
 */
export const useTitle = (title: string, customBaseTitle?: string) => {
  const { getSetting } = useSettings();
  
  useEffect(() => {
    const baseTitle = customBaseTitle || getSetting('site_name') || 'NextGen - Shop';
    const previousTitle = document.title;
    document.title = title ? `${title} - ${baseTitle}` : baseTitle;

    // Cleanup function to restore previous title if needed
    return () => {
      // Only restore if the title hasn't been changed by another component
      if (document.title === `${title} - ${baseTitle}`) {
        document.title = previousTitle;
      }
    };
  }, [title, customBaseTitle, getSetting]);
};